import React from 'react'
import { Button, Form, Loader } from 'semantic-ui-react'
import { useFormatMessage } from '../../utils/intlHelpers'

export interface ApexUsernameCheckProps {
  username: string
  usernameError: boolean
  handleSubmit: () => void
  handleChangeUsername: (username: string) => void
  checkingUserLoggedIn: boolean
  isLoginTypeLoading: boolean
}

export const ApexUsernameCheck = ({
  username,
  usernameError,
  handleSubmit,
  handleChangeUsername,
  checkingUserLoggedIn,
  isLoginTypeLoading,
}: ApexUsernameCheckProps) => {
  const formatMessage = useFormatMessage()
  const loading = isLoginTypeLoading || checkingUserLoggedIn
  return loading ? (
    <Loader active={loading} />
  ) : (
    <Form onSubmit={handleSubmit}>
      <Form.Input
        className={'test-id-check-username'}
        value={username}
        label={formatMessage('login.idpuserCheck')}
        onChange={(e, data) => handleChangeUsername(data.value)}
        required={true}
        disabled={checkingUserLoggedIn}
        error={
          usernameError && {
            content: formatMessage('login.username.required'),
          }
        }
      />
      <Form.Field>
        {formatMessage('login.username.security.message')}
      </Form.Field>
      <Button
        className={'test-id-check-username-submit'}
        type="submit"
        fluid={true}
        disabled={loading}
      >
        {formatMessage('common.next')}
      </Button>
    </Form>
  )
}
